import type {
    Control,
    FieldErrors,
    FieldValues,
    Path,
    UseFormRegister,
} from 'react-hook-form';
import type { StackProps } from 'tamagui';

import { SSN_MASK } from '../../utils/maskUtils';
import type { InputProps } from '../inputs/Input';
import { SSNInput } from '../inputs/SSNInput';
import { ControlledFormattedInput } from './ControlledFormattedInput';
import { createMaskFormatter } from './ControlledPhoneNumberInput';

interface ControlledSSNInputProps<
    TFieldValues extends FieldValues,
    TContext,
> extends Omit<InputProps, 'formatValueOnChange'> {
    name: Path<TFieldValues>;
    control: Control<TFieldValues, TContext>;
    register: UseFormRegister<TFieldValues>;
    errors: FieldErrors<TFieldValues>;
    storeUnmasked?: boolean;
    showValue?: boolean;
    allowToggle?: boolean;
    label?: string;
    hint?: string;
    containerStyle?: StackProps;
    rightSideContent?: React.ReactNode;
}

export const ControlledSSNInput = <TFieldValues extends FieldValues, TContext>({
    storeUnmasked = true,
    showValue = false,
    allowToggle = true,
    ...props
}: ControlledSSNInputProps<TFieldValues, TContext>) => {
    return (
        <ControlledFormattedInput
            {...props}
            formatter={createMaskFormatter(SSN_MASK, storeUnmasked)}
            InputComponent={SSNInput}
            inputComponentProps={{
                placeholder: props.placeholder ?? '123-45-6789',
                showValue,
                allowToggle,
            }}
        />
    );
};
